import { render, staticRenderFns } from "./speechItem.vue?vue&type=template&id=47b2f0f5&"
import script from "./speechItem.vue?vue&type=script&lang=js&"
export * from "./speechItem.vue?vue&type=script&lang=js&"
import style0 from "./speechItem.vue?vue&type=style&index=0&id=47b2f0f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports